import React, { Fragment, ReactNode } from 'react';
import { IMilestoneCategory } from '../api/getMilestone';
import { mileStoneCategoryName, milestoneCategories } from './common/constants/milestones';
import { IMilestoneHistory } from './common/types/milestones';

type IMilestoneStatus =
    | 'achieved'
    | 'under_observation'
    | 'delayed'
    | 'achieved_delay'
    | 'achieved_early'
    | 'achieved_unknown';

const statusObj: Record<IMilestoneStatus, { name: string; icon?: ReactNode }> = {
    achieved: {
        name: 'Achieved',
        icon: <span className="rounded-full p-6 bg-darwin-green-primary"></span>,
    },
    under_observation: {
        name: 'Under observation',
        icon: <span className="rounded-full p-6 bg-darwin-accent-bright-yellow-800"></span>,
    },
    delayed: {
        name: 'Delayed',
        icon: <span className="rounded-full p-6 bg-red-primary"></span>,
    },
    achieved_delay: {
        name: 'Achieved after delay',
        icon: <span className="rounded-full p-6 bg-darwin-green-primary"></span>,
    },
    achieved_early: {
        name: 'Achieved delay',
        icon: <span className="rounded-full p-6 bg-darwin-green-primary"></span>,
    },
    achieved_unknown: {
        name: 'Achieved',
        icon: <span className="rounded-full p-6 bg-darwin-green-primary"></span>,
    },
};

const MilestoneStatusSummary: React.FC<{
    milestoneSummary: {
        result?: Record<
            IMilestoneCategory,
            {
                achieved?: boolean | undefined;
                under_observation?: boolean | undefined;
                delayed?: boolean | undefined;
            }
        >;
        statuses?: IMilestoneHistory[];
    };
    className?: string;
}> = ({ milestoneSummary, className }) => {
    const { result, statuses } = milestoneSummary;

    const statusArr = Object.keys(statusObj).filter(
        (key) => key !== 'achieved_early' && key !== 'achieved_delay' && key !== 'achieved_unknown',
    );

    return (
        <div className={`flex flex-wrap items-center gap-12 ${className}`}>
            {result ? (
                statusArr.map((p) => {
                    const currObj = statusObj[p as IMilestoneStatus];
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    const categoryList = milestoneCategories
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        .filter((cat) => result?.[cat]?.[p] === true)
                        .map((cat) => mileStoneCategoryName[cat]);

                    return !categoryList.length && statuses?.length && p === 'achieved' ? null : (
                        <div className="flex items-center text-13 gap-8">
                            {currObj?.icon}
                            <p>
                                {currObj?.name}:{' '}
                                <span className="font-700">
                                    {categoryList.length ? categoryList.join(', ') : 'None'}
                                </span>
                            </p>
                        </div>
                    );
                })
            ) : (
                <Fragment>
                    {statusArr.map((key) => (
                        <div className="flex items-center text-13 gap-8">
                            {statusObj[key as IMilestoneStatus]?.icon}
                            <p>
                                {statusObj[key as IMilestoneStatus]?.name}:{' '}
                                <span className="font-700">None</span>
                            </p>
                        </div>
                    ))}
                </Fragment>
            )}
        </div>
    );
};

export default MilestoneStatusSummary;
